<template>
  <div class="card">
    <h2>Crear cuenta</h2>
    <div class="row">
      <div class="col">
        <label>Usuario</label>
        <input class="input" v-model="username">
      </div>
      <div class="col">
        <label>Email</label>
        <input class="input" v-model="email">
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label>Nombre visible</label>
        <input class="input" v-model="displayName">
      </div>
      <div class="col">
        <label>Contraseña</label>
        <input class="input" type="password" v-model="password">
      </div>
    </div>
    <div style="margin-top:12px;">
      <button class="btn" @click="submit" :disabled="loading">{{ loading ? 'Creando...' : 'Crear cuenta' }}</button>
      <router-link to="/login" style="margin-left:12px;">¿Ya tienes cuenta?</router-link>
    </div>
    <p v-if="error" style="color:#c92a2a;margin-top:10px;">{{ error }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data: () => ({ username: '', email: '', displayName: '', password: '', loading: false, error: null }),
  methods: {
    ...mapActions(['register']),
    async submit() {
      this.error = null; this.loading = true;
      try {
        await this.register({ username: this.username, email: this.email, password: this.password, displayName: this.displayName });
        this.$router.replace('/');
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || 'Error al crear cuenta';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
